module.exports = __webpack_public_path__ + "static/media/comment-minus.01ed90a4.svg";